import { forwardRef } from "react";
import type { ComponentPropsWithRef } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Event } from "@circle-react/types/Event";

interface EventItemButtonProps extends ComponentPropsWithRef<"button"> {
  ["aria-label"]: string;
  event: Event;
  eventInfo: {
    event: any;
    timeText: string;
  };
  isOneDayEvent: boolean;
}

export const EventItemButton = forwardRef<
  HTMLButtonElement,
  EventItemButtonProps
>(({ isOneDayEvent, eventInfo, event, ...props }, ref) => {
  const isDraft = event.status === "draft";
  return (
    <button
      ref={ref}
      type="button"
      className={classNames(
        "flex w-full justify-between space-x-2 px-2 text-xs font-semibold",
        isOneDayEvent
          ? "text-dark group-hover:text-inherit"
          : "group-hover:bg-circle rounded text-white group-hover:rounded",
      )}
      {...props}
    >
      <span className="truncate">{eventInfo.event.title}</span>
      <span
        className={classNames(
          isOneDayEvent ? "text-light group-hover:text-inherit" : "text-white",
          {
            uppercase: !isDraft,
          },
        )}
      >
        {isDraft ? t("events.badge_status.draft") : eventInfo.timeText}
      </span>
    </button>
  );
});

EventItemButton.displayName = "EventItemButton";
